export const ICONS_LOGO_PATH = {
    // Programming languages
    "Bash": "/assets/skillIcons/bash.svg",
    "C": "/assets/skillIcons/c.svg",
    "C++": "/assets/skillIcons/c++.svg",
    "C#": "/assets/skillIcons/c-sharp.svg",
    "CSS": "/assets/skillIcons/css3.svg",
    "Golang": "/assets/skillIcons/golang.svg",
    "HTML": "/assets/skillIcons/html5.svg",
    "Java": "/assets/skillIcons/java.svg",
    "JavaScript": "/assets/skillIcons/javascript.svg",
    "LaTex": "/assets/skillIcons/latex.svg",
    "PHP": "/assets/skillIcons/php.svg",
    "Python": "/assets/skillIcons/python.svg",
    "SQL": "/assets/skillIcons/sql.png",
    // Frameworks
    "Dojo": "/assets/skillIcons/dojo.svg",
    "Expo": "/assets/skillIcons/expo.svg",
    "Express": "/assets/skillIcons/express.svg",
    "LoopBack4": "/assets/skillIcons/loopback.svg",
    "Node.js": "/assets/skillIcons/nodejs.png",
    "React": "/assets/skillIcons/react.png",
    "React Native": "/assets/skillIcons/react.png",
    "Redux": "/assets/skillIcons/redux.svg",
    "Unity": "/assets/skillIcons/unity.svg",
    // Databases
    "IBM Db2": "/assets/skillIcons/db2.png",
    "MongoDB": "/assets/skillIcons/mongodb.png",
    "MySQL": "/assets/skillIcons/mysql.svg",
    "DynamoDB": "/assets/skillIcons/aws-dynamodb.svg",
    // Testing
    "Chai": "/assets/skillIcons/chai.png",
    "JUnit": "/assets/skillIcons/junit.png",
    "Mocha": "/assets/skillIcons/mocha.svg",
    "Mockito": "/assets/skillIcons/mockito.png",
    "pytest": "/assets/skillIcons/pytest.svg",
    "Selenium": "/assets/skillIcons/selenium.svg",
    // Cloud & Container Platforms
    "AWS": "/assets/skillIcons/aws.svg",
    "AWS S3": "/assets/skillIcons/aws-s3.svg",
    "AWS EC2": "/assets/skillIcons/aws-ec2.svg",
    "AWS Lambda": "/assets/skillIcons/aws-lambda.svg",
    "AWS API Gateway": "/assets/skillIcons/aws-api-gateway.svg",
    "AWS Step Functions": "/assets/skillIcons/aws-step-functions.svg",
    "AWS Route53": "/assets/skillIcons/aws-route53.svg",
    "AWS Cloudfront": "/assets/skillIcons/aws-cloudfront.svg",
    "Azure": "/assets/skillIcons/azure.svg",
    "Docker": "/assets/skillIcons/docker.svg",
    "GCP": "/assets/skillIcons/gcp.svg",
    "Red Hat OCP": "/assets/skillIcons/ocp.png",
    // Libraries
    "Flask": "/assets/skillIcons/flask.svg"
};